import retailerSorts from '@/useCases/filters/retailerSorts'
import { IFilterCopy } from '~types/search'
import { buildOptions } from './buildOptions'

const getRetailerSorts = ({
  copy,
  sortOptionsConfig,
}: {
  copy: IFilterCopy
  sortOptionsConfig: string[]
}) => {
  const sortOptionsFiltered = retailerSorts(sortOptionsConfig)
  const sortOptions = copy?.sort || {}
  return buildOptions(sortOptions, sortOptionsFiltered)
}

export default getRetailerSorts
